import React from "react";

/**
 * Universal Zorbastays Loader
 * Use this everywhere instead of page-specific spinners so loading state
 * looks identical across the whole app.
 *
 * Usage:
 *   <Loader />                          -> fullscreen page loader
 *   <Loader fullScreen={false} />       -> inline loader (inside a card/table/etc)
 *   <Loader label="Fetching bookings..." />
 *   <Loader size="sm" fullScreen={false} />
 */
const Loader = ({
  fullScreen = true,
  label = "Loading...",
  size = "md",
}) => {
  const sizeMap = {
    sm: 64,
    md: 110,
    lg: 150,
  };
  const ring = sizeMap[size] || sizeMap.md;

  const spinner = (
    <div className="flex flex-col items-center justify-center gap-4">
      <img
        src="/assets/Zorba_loader_transparent.gif"
        alt="Loading"
        style={{ width: ring, height: ring, objectFit: "contain" }}
      />

      {label && (
        <p className="text-sm font-medium text-gray-500 tracking-wide">
          {label}
        </p>
      )}
    </div>
  );

  if (!fullScreen) {
    return <div className="w-full py-10 flex justify-center">{spinner}</div>;
  }

  // Fills the space it's placed in (e.g. <main>) rather than the whole
  // viewport, so a persistent sidebar/menubar rendered alongside it stays
  // visible while this page's content is loading.
  return (
    <div className="w-full min-h-[80vh] flex items-center justify-center">
      {spinner}
    </div>
  );
};

export default Loader;